'use client';

import { useAskInputSuggestion } from '@/features/conversations/hooks/useAskInputSuggestion';
import { createContext, useContext } from 'react';

const AskInputContext = createContext<ReturnType<
	typeof useAskInputSuggestion
> | null>(null);

export const AskInputSuggestionProvider = ({
	children,
}: { children: React.ReactNode }) => {
	const askInput = useAskInputSuggestion();
	return (
		<AskInputContext.Provider value={askInput}>
			{children}
		</AskInputContext.Provider>
	);
};

export const useAskInputContext = () => {
	const context = useContext(AskInputContext);
	if (!context) {
		throw new Error(
			'useAskInputContext must be used within AskInputSuggestionProvider',
		);
	}
	return context;
};
